import { useEffect, useState } from "react";
import { getTutorFeatures } from "../services/TutorFeaturesService";

/**
 * Loads {@code app.tutor.enable} from GET /home/sys/features.
 * Defaults to false until the request succeeds.
 */
export default function useTutorEnable() {
    const [tutorEnable, setTutorEnable] = useState(false);
    const [ready, setReady] = useState(false);

    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                const features = await getTutorFeatures();
                if (!cancelled) {
                    setTutorEnable(Boolean(features?.tutorEnable));
                }
            } catch {
                if (!cancelled) {
                    setTutorEnable(false);
                }
            } finally {
                if (!cancelled) {
                    setReady(true);
                }
            }
        })();
        return () => {
            cancelled = true;
        };
    }, []);

    return { tutorEnable, ready };
}
